import React from 'react'
import SkillBoxCart from '../feature/SkillBox/SkillBoxCart'

const SkillBoxCartPage = () => {
  return (
   <SkillBoxCart/>
  )
}

export default SkillBoxCartPage
